import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import icon from "../assets/icon.png";
import pivot0 from "../assets/pivot0.png";
import pivot from "../assets/pivot.png";
import pivot2 from "../assets/pivot2.png";

const images = [pivot2, pivot, pivot0];

const Home = () => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 3000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="container">
            {/* <div
                className="jumbotron mt-5"
                style={{
                    backgroundImage: `url(${images[currentImageIndex]})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center 65%",
                    backgroundRepeat: "no-repeat",
                    color: "white",
                    padding: "3rem",
                    borderRadius: "10px",
                    height: "500px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    position: "relative",
                    transition: "background-image 1s ease-in-out",
                }}
            >
                <div
                    style={{
                        backgroundColor: "rgba(184, 221, 243, 0.5)",
                        backdropFilter: "blur(2px)",
                        padding: "2rem",
                        borderRadius: "15px",
                        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
                        maxWidth: "80%",
                    }}
                >
                    <img
                        src={icon}
                        alt="Icon"
                        style={{ width: "100px", height: "auto", marginBottom: "1rem" }}
                    />
                    <h1
                        className="display-3"
                        style={{ color: "#000000", fontSize: "3.5rem", fontWeight: "450" }}
                    >
                        InteliRain™ Web Application
                    </h1>
                    <p
                        className="lead"
                        style={{ color: "#000000", fontSize: "1.5rem", fontWeight: "350" }}
                    >
                        Advancing Irrigation Through Science
                    </p>
                    <hr
                        className="my-4"
                        style={{ borderColor: "white", width: "80%", margin: "1rem auto" }}
                    />
                    <Link
                        to="/login"
                        className="btn btn-primary btn-lg"
                        role="button"
                        style={{
                            fontSize: "1.2rem",
                            padding: "0.8rem 2rem",
                            backgroundColor: "#0064FF",
                            color: "white",
                            border: "2px solid #000000",
                            borderRadius: "5px",
                        }}
                    >
                        Get Started
                    </Link>
                </div>
            </div> */}
        </div>
    );
};

export default Home;
